import { Text } from '@vkontakte/vkui';
import formatFns from 'date-fns/format';
import ruLocale from 'date-fns/locale/ru';
import freemiumEndedImage from 'img/freemium/freemiumEnded.png';
import freemiumEndedImageDark from 'img/freemium/freemiumEndedDark.png';
import React from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { closeCommonWhatsNewDialog, renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

import { markEndedModalClosed } from '../Freemium/freemiumModals.helpers';
import styles from './FreemiumEndedModal.css';

const TARIFF_ID_WITH_DISCOUNT = 'W256GB_1m_family_features_discount_3m';

interface FreemiumEndedModalProps {
    expiresDate?: number | null;
}

const getAnalyticsName = (): string => {
    if (isHardFreemium) {
        return 'mnz_sub_ended_unlimited_hard_freemium';
    }
    if (isSoftFreemium) {
        return 'mnz_sub_ended_unlimited_soft_freemium';
    }
    return 'mnz_sub_ended_unlimited_soft_freemium';
};

const getPaySource = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_unlimited_hard_freemium_modal_sub_ended';
    }
    if (isSoftFreemium) {
        return 'mnz_family_unlimited_soft_freemium_modal_sub_ended';
    }
    return 'mnz_family_unlimited_soft_freemium_modal_sub_ended';
};

export const renderFreemiumEndedModal = ({ expiresDate }: FreemiumEndedModalProps): void => {
    const analyticsName = getAnalyticsName();
    const paySource = getPaySource();

    sendDwh({
        eventCategory: 'modal',
        action: 'show',
        dwhData: {
            name: analyticsName,
        },
        dwh_enabled: true,
    });

    const handleClick = async () => {
        closeCommonWhatsNewDialog();
        sendDwh({
            eventCategory: 'modal',
            action: 'click',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });

        await productsController.loadProducts();
        reduxStore.dispatch(
            openTariffBuy({
                productId: TARIFF_ID_WITH_DISCOUNT,
                paySource,
                title: 'Семейный тариф Mail Space',
            })
        );
    };

    const handleClose = () => {
        sendDwh({
            eventCategory: 'modal',
            action: 'close',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
        markEndedModalClosed();
    };

    const text = 'Подключите её со скидкой, чтобы снова скрыть рекламу в Mail и вернуть безлимит для фото и видео с телефона';

    const content = (
        <div className={styles.items}>
            <Text className={styles.text}>{text}</Text>
        </div>
    );

    let imageAdditionalContent: React.ReactElement | undefined;
    if (expiresDate) {
        const formattedDate = formatFns(expiresDate, 'd.MM', { locale: ruLocale });
        imageAdditionalContent = (
            <div className={styles.imageText}>
                <div className={styles.imageTitle}>
                    256<span className={styles.imageTitleSmall}> ГБ</span>
                </div>
                <div className={styles.imageSubtitle}>Пробная подписка до {formattedDate}</div>
            </div>
        );
    }

    renderCommonWhatsNewDialog({
        title: 'У вас закончилась пробная подписка',
        titleClassName: styles.modalTitle,
        content,
        primaryButtonText: 'Подключить со скидкой',
        primaryButtonClassName: styles.primaryButton,
        imageUrl: isDarkTheme ? freemiumEndedImageDark : freemiumEndedImage,
        imageWrapperClassName: styles.imageWrapper,
        imageAdditionalContent,
        closable: true,
        closeOnEscape: true,
        closeOnDimmerClick: true,
        onClick: handleClick,
        onClose: handleClose,
    });
};
